//code is commented so that it can be used as a bower component
(function(angular) {
    'use strict';

    angular.module('bluemoon.notes', [
        'bluemoon.notes.templates',
        'bento.modern',
        'ui.bootstrap',
        'pascalprecht.translate',
        'bluemoon.components',
        'bmFroala'
    ])
    .value('bmnFroalaOptions', {
        inlineMode: false,
        placeholder: '',
        buttons: ['bold', 'italic', 'underline', 'strikeThrough', 'undo', 'redo'],
        toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'undo', 'redo'],
        quickInsertButtons: ['ul', 'ol', 'hr'],
        paragraphy: false,
        minHeight: '61px',
        plainPaste: true,
        pasteImage: false,
        //allowedTags: [],
        customButtons: {
            title: 'Clear HTML',
            icon: {
                type: 'font',
                value: 'fa fa-times'
            },
            callback: function() {}
        }
    });

}(window.angular));

/**
 * Notes Directive
 */
(function(angular, $) {
    'use strict';
    angular.module('bluemoon.notes')
        .directive('bmnNote', ['$uibModal', function($uibModal) {
            return {
                restrict: 'AE',
                scope: {
                    commentCount: '@',
                    entityId: '@',
                    entityName: '@',
                    icon: '@',
                    noteType: '@',
                    isLocked: '@'
                },
                templateUrl: 'notes/notes.2js.html',
                link: function(scope) {
                    //opens a modal window for the note,
                    //we pass the company id and entity up to the modal
                    scope.isDisabled = (scope.isLocked !== undefined && scope.isLocked !== '' && JSON.parse(scope.isLocked).resourceRestrictions !== undefined && JSON.parse(scope.isLocked).resourceRestrictions.indexOf('COMMENTS') > -1) ? true : false;
                    scope.open = function() {
                        $uibModal.open({
                            templateUrl: 'notes/notes-modal.2js.html',
                            controller: 'bmnNotesModalCtrl',
                            size: 'lg',
                            backdrop: 'static',
                            resolve: {
                                noteData: function() {
                                    var entity = {
                                        id: scope.entityId,
                                        name: scope.entityName,
                                        icon: scope.icon,
                                        locked: scope.isLocked
                                    };

                                    var data = {
                                        type: scope.noteType,
                                        entity: entity
                                    };

                                    return data;
                                }
                            }
                        });
                    };

                    scope.getCommentsCursorStyle = function() {
                        return scope.isDisabled ? 'cursor-not-allowed' : 'cursor-pointer';
                    };
                }
            };
        }])
        .controller('bmnNotesModalCtrl', ['$rootScope', '$scope', '$uibModalInstance', 'bmnNoteService', 'noteData', function($rootScope, $scope, $uibModalInstance, noteService, note) {
            $scope.isLoaderBusy = false;
            $scope.isInAddMode = false;
            $scope.isInEditMode = false;
            $scope.alerts = [];
            $scope.noteToEdit = {};
            $scope.note = note;
            $scope.isDisabled = false;
            loadNotes();

            $scope.$on('enteringAddMode', function() {
                //broadcast this event to the existing notes so that they know to hide their edit buttons
                $scope.$broadcast('parentEnteringAddMode', null);
                $scope.isInAddMode = true;
            });

            $scope.$on('leavingAddMode', function() {
                //broadcast this event to the existing notes so that they know to show their edit buttons
                $scope.$broadcast('parentLeavingAddMode', null);
                $scope.isInAddMode = false;
            });

            $scope.$on('enteringEditMode', function(event, note) {
                //broadcast this event to the new note directive, so that it will disable its buttons
                $scope.noteToEdit = note;
                $scope.$broadcast('parentEnteringEditMode', note);
                $scope.isInEditMode = true;
            });

            //something told us to turn on the busy loader
            $scope.$on('turnOnBusyLoader', function() {
                $scope.isLoaderBusy = true;
            });

            //something told us to turn off the busy loader
            $scope.$on('turnOffBusyLoader', function() {
                $scope.isLoaderBusy = false;
            });

            $scope.$on('leavingEditMode', function(event, note) {
                //broadcast this event to the new note directive, so that it will enable its buttons
                leaveEditMode(note);
            });

            //update our scope because a child was updated
            $scope.update = function(note) {
                if (note !== null) {
                    for (var i = 0; i < $scope.notes.length; i++) {
                        if ($scope.notes[i].id === note.id) {
                            $scope.notes[i] = note;
                        }
                    }
                    leaveEditMode();
                    scrollWindowToTop();
                }
            };

            //notification from the existing-comment controller, telling us to remove a note
            var unlistenBmnNoteDeleted = $rootScope.$on('bmnNoteDeleted', function(event, note) {
                var index = $scope.notes.indexOf(note);
                if (index > -1) {
                    $scope.notes.splice(index, 1);
                }
                leaveEditMode(note);
            });

            //notification from the new-note controller, telling us to add a note
            var unlistenBmnNoteAdded = $rootScope.$on('bmnNoteAdded', function(event, note) {
                $scope.notes.push(note);
                scrollWindowToTop();
                //Closing the busy loader after adding the note
                $scope.isLoaderBusy = false;
            });

            //method to display any alerts (errors, success) that we may need
            $scope.$on('note-alert', function(event, data) {
                noteAlert(data);
            });

            //Logic to handle leaving edit mode
            //clear the note to edit object
            //and notifify the new note directive
            function leaveEditMode(note) {
                $scope.noteToEdit = {};
                $scope.$broadcast('parentLeavingEditMode', note);
                $scope.isInEditMode = false;
            }

            //function to display alert messages
            //see bento modern docs for types
            function noteAlert(data) {
                $scope.alerts.push({
                    type: data.Type,
                    msg: data.Message,
                    timeout: data.Timeout,
                    closeable: true
                });
            }

            //After an add or edit, we want to scroll to the top of our list
            function scrollWindowToTop() {
                $('.bmn-comment-list').scrollTop(0);
            }

            //load the notes and show the busy loader while its working
            function loadNotes() {
                $scope.isLoaderBusy = true;
                noteService.getNotes(note.entity.id).then(function(requestResult) {
                    $scope.isLoaderBusy = false;
                    if (requestResult.result === 'success') {
                        $scope.notes = requestResult.data;
                        const element = document.getElementsByClassName('froala-element');
                        if(element && element.length !== 0) {
                            element[0].setAttribute('aria-labelledby', 'addCommentLabel');
                            element[0].setAttribute('aria-required', true);
                            element[0].setAttribute('role', 'textbox');
                        }

                    } else {
                        noteAlert({
                            Type: 'danger',
                            Message: 'The notes failed to load',
                            Timeout: 2500
                        });
                    }
                });
            }

            //close the modal
            $scope.done = function() {
                $uibModalInstance.close();
            };

            $scope.$on('$destroy', function() {
                unlistenBmnNoteAdded();
                unlistenBmnNoteDeleted();
            });
        }]);
})
(window.angular, window.$);

(function() {
    'use strict';
    angular.module('bluemoon.notes')
        .directive('bmnNoteDateString', [function() {
        return {
            restrict: 'E',
            scope: {
                timestamp: '=timestamp'
            },
            templateUrl: 'notes/note-date-string.2js.html',
            link: function(scope) {
                init();

                //if the timestamp changes, update the string
                scope.$watch('timestamp', function() {
                    init();
                });

                //main logic to setup the timestamp
                function init() {
                    var currentTime = new Date();

                    //object to hold the date formats
                    scope.formats = {
                        minutes: 0,
                        hours: 1,
                        full: 2
                    };

                    scope.format = scope.formats.full;
                    //subtract our timestamp from the current time to get the difference
                    var timeDifference = currentTime - new Date(scope.timestamp);

                    //difference in minutes
                    scope.diffMins = Math.round(((timeDifference % 86400000) % 3600000) / 60000); //mins

                    //difference in hours
                    scope.diffHours = Math.round((timeDifference % 86400000) / 3600000); // hours

                    //difference in days
                    scope.diffDays = Math.round(timeDifference / 86400000); // days

                    if (scope.diffMins < 60 && scope.diffHours < 1 && scope.diffDays <= 0) {
                        //show the timestamp as '# mins ago'
                        scope.format = scope.formats.minutes;
                    } else if (scope.diffHours < 24 && scope.diffDays < 1) {
                        // show the timestamp as '# of hours ago'
                        scope.diffHours = scope.diffHours;
                        scope.format = scope.formats.hours;
                    }
                }
            }
        };
    }]);
})();

(function() {
    'use strict';
    angular.module('bluemoon.notes')
        .directive('bmnExistingNote', ['bmnNoteService', 'NotesClientManager', function(noteService, NotesClientManager) {
        return {
            restrict: 'E',
            scope: {
                note: '=note',
                isLocked: '@'
            },
            templateUrl: 'notes/existing-note.2js.html',
            link: function(scope) {
                scope.createdByCurrentUser = false;
                scope.enteredText = scope.note.notedata;
                scope.isParentInAddMode = false;
                scope.isDisabled = (scope.isLocked !== undefined && scope.isLocked !== '' && JSON.parse(scope.isLocked).resourceRestrictions !== undefined && JSON.parse(scope.isLocked).resourceRestrictions.indexOf('COMMENTS') > -1) ? true : false;
                //need to know if the edit window updated us
                scope.$watch('note', function(){
                  scope.enteredText = scope.note.notedata;
                });

                //if the current user is the creator of the current note, set the createdByCurrentUser to true
                //this allows them to edit the note
                NotesClientManager.getBindings().then(function(bindingsResult) {
                    if (bindingsResult) {
                        scope.createdByCurrentUser = bindingsResult.ApplicationConfiguration.ContactId === scope.note.createdbyid;
                    }
                });

                //The parent is in add mode, so hide our edit button
                scope.$on('parentEnteringAddMode', function() {
                    scope.isParentInAddMode = true;
                });

                //the parent left add mode, so its ok to show the edit button again
                scope.$on('parentLeavingAddMode', function() {
                    scope.isParentInAddMode = false;
                });

                scope.$on('parentLeavingEditMode', function() {
                    scope.editingAnother = false;
                    scope.editingThis = false;
                });

                scope.$on('parentEnteringEditMode', function() {
                    if (!scope.editingThis) {
                        scope.editingAnother = true;
                    }
                });

                scope.getCommentsCursorStyle = function() {
                        return scope.isDisabled ? 'cursor-not-allowed' : 'cursor-pointer';
                };

                //Toggle the edit mode
                scope.editClick = function() {
                    scope.$emit('enteringEditMode', scope.note);
                    scope.editingThis = true;
                    scope.enteredText = scope.note.notedata;
                };
            }
        };
    }]);
})();

(function() {
    'use strict';
    angular.module('bluemoon.notes')

    .directive('bmnEditNote', ['$rootScope', '$timeout', 'bmnNoteService', function($rootScope, $timeout, noteService) {
        return {
            restrict: 'E',
            scope: {
                note: '=note',
                isLocked: '@',
                parentUpdate: '&'
            },
            templateUrl: 'notes/edit-note.2js.html',
            controller: ['$scope', '$timeout', '$translate', 'bmLanguageManager', 'bmnFroalaOptions', function($scope, $timeout, $translate, languageManager, froalaOptions) {
                $scope.froalaOptions = froalaOptions;
                $scope.froalaOptions.events = {
                    'froalaEditor.initialized' : function(e, editor) {
                        if(editor) {
                            $translate('bmn.AddAComment').then(function(s){
                                editor.opts.placeholderText = s;
                                editor.events.focus(true);
                            });
                        }
                    }
                };
                $scope.froalaOptions.language = languageManager.getCurrentLanguage();
            }],
            link: function(scope) {
                scope.isDisabled = (scope.isLocked !== undefined && scope.isLocked !== '' && JSON.parse(scope.isLocked).resourceRestrictions !== undefined && JSON.parse(scope.isLocked).resourceRestrictions.indexOf('COMMENTS') > -1) ? true : false;
                scope.submitClick = function() {
                    var isValid = scope.validate();
                    if (isValid) {
                        scope.commentSubmit();
                    }
                };

                scope.validate = function() {
                    var commentErrors = scope.editCommentForm.comment.$error;
                    commentErrors.count = 0;

                    commentErrors.required = false;
                    if (!scope.enteredText) {
                        commentErrors.required = true;
                        commentErrors.count++;
                        return false;
                    }

                    return true;
                };

                var unwatchLanguageChangeSuccess = $rootScope.$on('bmLanguageChangeSuccess', function(event, changeArgs) {
                    scope.froalaOptions.froala('option', 'language', changeArgs.language);
                });

                var unwatchParentEnteringEditMode = scope.$on('parentEnteringEditMode', function(event, note) {
                    scope.enteredText = note.notedata;
                });

                scope.$on('$destroy', function() {
                    unwatchLanguageChangeSuccess();
                    unwatchParentEnteringEditMode();
                });

                //set the entered text back to the notedata and leave edit mode
                scope.cancelClick = function() {
                    scope.enteredText = scope.note.notedata;
                    scope.$emit('leavingEditMode');
                };

                scope.commentSubmit = function() {
                    scope.note.notedata = scope.enteredText;
                    scope.$emit('turnOnBusyLoader');
                    noteService.updateNote(scope.note).then(function(requestResult) {
                        //if the update was successful, set the current note's object to the returned note
                        if (requestResult.result === 'success') {
                            //make sure we didn't get back an empty array
                            if (requestResult.data.length > 0) {
                                //give the current note the return object
                                scope.note = requestResult.data[0];
                                $timeout(scope.parentUpdate);
                            }
                        } else {
                            scope.$emit('note-alert', {
                                Type: 'danger',
                                Message: 'The note failed to update.',
                                Timeout: 2500
                            });
                            scope.$emit('leavingEditMode', null);
                        }
                        scope.$emit('turnOffBusyLoader');
                    });
                };

                scope.deleteClick = function() {
                    //call into the service and delete the note.
                    //then notifiy the modalInstanceCtrl to remove the note from its list
                    noteService.deleteNote(scope.note).then(function(requestResult) {
                        if (requestResult.result === 'success') {
                            $rootScope.$emit('bmnNoteDeleted', scope.note);
                        } else {
                            scope.$emit('note-alert', {
                                Type: 'danger',
                                Message: 'The note failed to delete.',
                                Timeout: 2500
                            });
                        }
                    });
                };

                scope.enteredText = scope.note.notedata;
                $timeout(function() {
                    //To reset the undo stack
                    scope.froalaOptions.froalaEditor('undo.reset', true);
                });
            }
        };
    }]);
})();

(function() {
    'use strict';
    angular.module('bluemoon.notes')
        .directive('bmnNewNote', ['$rootScope', '$timeout', 'bmnNoteService', function($rootScope, $timeout, noteService) {
        return {
            restrict: 'E',
            scope: {
                entityId: '@',
                noteType: '@',
                isLocked: '@'
            },
            templateUrl: 'notes/new-note.2js.html',
            controller: ['$scope', '$timeout', '$translate', 'bmLanguageManager', 'bmnFroalaOptions', function($scope, $timeout, $translate, languageManager, froalaOptions) {
                $scope.froalaOptions = froalaOptions;
                $scope.froalaOptions.events = {
                    'froalaEditor.initialized' : function(e, editor) {
                        if(editor) {
                            $translate('bmn.AddAComment').then(function(s){
                                editor.opts.placeholderText = s;
                                // To automatically focus the editor when it opens.
                                editor.events.focus(true);
                            });
                        }
                    }
                };
                $scope.froalaOptions.language = languageManager.getCurrentLanguage();
                $scope.froalaOptions.tabSpaces = false;

            }],
            link: function(scope) {
                scope.isInAddMode = false;
                scope.enteredText = '';
                scope.isDisabled = (scope.isLocked !== undefined && scope.isLocked !== '' && JSON.parse(scope.isLocked).resourceRestrictions !== undefined && JSON.parse(scope.isLocked).resourceRestrictions.indexOf('COMMENTS') > -1) ? true : false;
                var unwatchLanguageChangeSuccess = $rootScope.$on('bmLanguageChangeSuccess', function(event, changeArgs) {
                    scope.froalaOptions.froala('option', 'language', changeArgs.language);
                });

                scope.submitClick = function() {
                    var isValid = scope.validate();
                    if (isValid) {
                        scope.commentSubmit();
                    }
                };

                scope.$on('$destroy', function() {
                    unwatchLanguageChangeSuccess();
                });

                scope.toggleAddMode = function() {
                    scope.isInAddMode = !scope.isInAddMode;
                    //if we're in add mode, notify our parent so it can disable the done button
                    if (scope.isInAddMode) {
                        scope.$emit('enteringAddMode', null);
                    } else {
                        scope.$emit('leavingAddMode', null);
                    }
                };

                scope.validate = function() {
                    var commentErrors = scope.addCommentForm.comment.$error;
                    commentErrors.count = 0;

                    commentErrors.required = false;
                    if (!scope.enteredText) {
                        commentErrors.required = true;
                        commentErrors.count++;
                        return false;
                    }

                    return true;
                };

                scope.commentSubmit = function() {
                    //spin up a new note
                    //this is a temporary hack to get this to work with the new post endpoint
                    //because it requires a list of notes
                    scope.$emit('turnOnBusyLoader');
                    noteService.addNote(scope.entityId, scope.noteType, scope.enteredText).then(function(requestResult) {
                        if (requestResult.result === 'success') {
                          if (requestResult.data.length > 0){
                            $rootScope.$emit('bmnNoteAdded', requestResult.data[0]);
                            scope.enteredText = '';

                            //To reset undo stack
                            scope.froalaOptions.froalaEditor('undo.reset', true);
                            //To automatically focus the editor
                            scope.froalaOptions.froalaEditor('events.focus', true);

                            scope.toggleAddMode();
                          }
                        } else {
                            scope.$emit('note-alert', {
                                Type: 'danger',
                                Message: 'The note failed to add.',
                                Timeout: 2500
                            });
                        }
                        scope.$emit('turnOffBusyLoader');
                    });
                };
            }
        };
    }]);
})();

(function(angular) {
    'use strict';

    angular.module('bluemoon.notes')
        .factory('httpRequestManager', httpRequestManager);

    httpRequestManager.$inject = ['$q', '$http', 'HttpResponseData'];

    function httpRequestManager($q, $http, HttpResponseData) {
        var factory = {
            getAnonymousHttpPostConfig: getAnonymousHttpPostConfig,
            getAnonymousHttpDeleteConfig: getAnonymousHttpDeleteConfig,
            getAnonymousHttpPutConfig: getAnonymousHttpPutConfig,
            getAnonymousHttpGetConfig: getAnonymousHttpGetConfig,
            getAuthenticatedHttpPostConfig: getAuthenticatedHttpPostConfig,
            getAuthenticatedHttpDeleteConfig: getAuthenticatedHttpDeleteConfig,
            getAuthenticatedHttpPutConfig: getAuthenticatedHttpPutConfig,
            getAuthenticatedHttpGetConfig: getAuthenticatedHttpGetConfig,
            makeHttpRequest: makeHttpRequest,
            getBaseServiceUri: getBaseServiceUri
        };

        return factory;

        function getBaseServiceUri(){
            //return 'http://localhost:2014/wp/api/workpapers/v1/';
            return '/api/notes/v1/';
        }

        // Provide an anonymous $http generic config
        function getBaseAnonymousRequestConfig(restServiceMethod, requestData, requestType){
            if(restServiceMethod === null || angular.isUndefined(restServiceMethod)){
                return null;
            }

            var config = {};
            config.method = requestType.toUpperCase();
            config.url = getBaseServiceUri() + restServiceMethod;

            if (requestData !== null && angular.isDefined(requestData)){
                config.data = requestData;
            }

            config.cache = false;
            return config;
        }

        ////////// Anonymous

        function getAnonymousHttpPostConfig(restServiceMethod, requestData) {
            return getBaseAnonymousRequestConfig(restServiceMethod, requestData, 'POST');
        }

        function getAnonymousHttpDeleteConfig(restServiceMethod, requestData) {
            var config = getBaseAnonymousRequestConfig(restServiceMethod, requestData, 'DELETE');

            if(config === null){
                return null;
            }

            config.headers = {
                'Content-Type': 'application/json; charset=utf-8',
                'Compress-Data': 'true'
            };

            return config;
        }

        function getAnonymousHttpPutConfig(restServiceMethod, requestData) {
            var config = getBaseAnonymousRequestConfig(restServiceMethod, requestData, 'PUT');

            if(config === null){
                return null;
            }

            config.headers = {
                'Content-Type': 'application/json; charset=utf-8',
                'Compress-Data': 'true'
            };

            return config;
        }

        function getAnonymousHttpGetConfig(restServiceMethod) {
            var config = getBaseAnonymousRequestConfig(restServiceMethod, null, 'GET');

            if(config === null){
                return config;
            }

            config.headers = {
                'Content-Type': 'application/json; charset=utf-8',
                'Compress-Data': 'true',
                'Accept': 'application/json'
            };

            return config;
        }

        ////////// Authenticated

        function getBaseAuthenticatedRequestConfig(restServiceMethod, requestData, requestType){
            var config = getBaseAnonymousRequestConfig(restServiceMethod, requestData, requestType);

            if(config === null){
                return null;
            }

            config.headers = {
                'Content-Type': 'application/json; charset=utf-8',
                'Compress-Data': 'true',
                'Accept': 'application/json'
            };

            return config;
        }

        function getAuthenticatedHttpPostConfig(restServiceMethod, requestData) {
            return getBaseAuthenticatedRequestConfig(restServiceMethod, requestData, 'POST');
        }

        function getAuthenticatedHttpDeleteConfig(restServiceMethod, requestData) {
            return getBaseAuthenticatedRequestConfig(restServiceMethod, requestData, 'DELETE');
        }

        function getAuthenticatedHttpPutConfig(restServiceMethod, requestData) {
            return getBaseAuthenticatedRequestConfig(restServiceMethod, requestData, 'PUT');
        }

        function getAuthenticatedHttpGetConfig(restServiceMethod) {
            return getBaseAuthenticatedRequestConfig(restServiceMethod, null, 'GET');
        }

        // Make an asynchronous rest service call
        function makeHttpRequest(httpConfig) {
            var deferred = $q.defer();

            if(httpConfig === null || angular.isUndefined(httpConfig)){
                deferred.reject(new HttpResponseData('error', 'WP.ERROR.INVALID_REQUEST', null, 'Invalid Request'));
                return deferred.promise;
            }

            $http(httpConfig).then(
                function(response) {
                    var status = angular.isUndefined(response) ? undefined : response.status;

                    // Make sure the status returned is successful
                    if(angular.isUndefined(status) || status < 200 || status > 299){
                        deferred.reject(new HttpResponseData('error', status, response.data, response.statusText));
                    } else {
                        deferred.resolve(new HttpResponseData('success', status, response.data, response.statusText));
                    }
                }, // TODO: UPDATE THIS WITH CORRECT ERROR FORMAT AND TRANSLATIONS
                function(response) {
                    deferred.reject(new HttpResponseData('error', response.status, response.data, response.statusText));
                }
            );

            return deferred.promise;
        }
    }
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.notes')
        .factory('HttpResponseData', httpResponseData);

    httpResponseData.$inject = [];

    function httpResponseData() {
        function HttpResponseData(result, status, data, message) {
            this.result = result;
            this.status = status;

            if (data !== null && angular.isObject(data) && angular.isDefined(data.data)) {
                this.data = data.data;
            } else {
                this.data = data;
            }

            this.message = message;
        }

        return HttpResponseData;
    }
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.notes')

        .factory('bmnNoteService', noteService);
    noteService.$inject = ['$location', '$q', 'bmUser', 'httpRequestManager', 'HttpResponseData'];

    function noteService($location, $q, bmUser, httpRequestManager, HttpResponseData) {
        var notesApi = '/api/notes/v1/comments/';
        var notesApiV2 = '/api/notes/v2/comments/';
        var factory = {
            getNoteCount: getNoteCount,
            getNotes: getNotes,
            updateNote: updateNote,
            addNote: addNote,
            deleteNote: deleteNote,
            initializeNote: initializeNote
        };

        //call into the request manager and return a promise
        var handleHttpRequest = function(config) {
            return httpRequestManager.makeHttpRequest(config);
        };

        //returns an error promise
        var handleInvalidNoteRequest = function() {
            var deferred = $q.defer();
            deferred.reject(new HttpResponseData('error', 'BMN.ERROR.INVALID_REQUEST_PARAMETERS', null, 'Invalid Request Parameters'));
            return deferred.promise;
        };

        //Gets counts for notes
        function getNoteCount(entityIds) {
            var config = httpRequestManager.getAnonymousHttpPostConfig('', entityIds);
            config.url = notesApi + 'search';
            return handleHttpRequest(config);
        }

        //Gets a list of notes given a company id and entity id
        function getNotes(entityId) {
            if (entityId === null || angular.isUndefined(entityId)) {
                return handleInvalidNoteRequest();
            }
            var config = httpRequestManager.getAuthenticatedHttpGetConfig('');
            config.url = notesApi + entityId;
            return handleHttpRequest(config);
        }

        //this wraps a single note in the correct object to send to the deleteNotes method
        function deleteNote(note) {
            if (note === null || angular.isUndefined(note)) {
                return handleInvalidNoteRequest();
            }
            //wrap the current note in an object with an array of comments (the current comment is the only one in the array)
            //because the endpoint expects a list of comments
            var noteToDelete = {
                Statuses: [{
                    Id: note.id,
                    IsDeleted: false
                }]
            };

            return deleteNotes(noteToDelete);
        }

        //this takes in an object with an array of statuses (to delete multiple)
        function deleteNotes(notesToDelete) {
            if (notesToDelete === null || angular.isUndefined(notesToDelete)) {
                return handleInvalidNoteRequest();
            }
            var config = httpRequestManager.getAuthenticatedHttpDeleteConfig('', notesToDelete);
            config.url = notesApiV2 + notesToDelete.Statuses[0].Id;
            return handleHttpRequest(config);
        }

        //This just wraps a single note object in the correct dto to send to the endpoint
        //which expects a list of notes
        function updateNote(note) {
            if (note === null || angular.isUndefined(note)) {
                return handleInvalidNoteRequest();
            }
            var noteToUpdate = {
                Comments: [note]
            };
            return updateNotes(noteToUpdate);
        }

        //updates a multiple notes
        function updateNotes(note) {
            if (note === null || angular.isUndefined(note)) {
                return handleInvalidNoteRequest();
            }
            var config = httpRequestManager.getAnonymousHttpPutConfig('', note);
            config.url = notesApi;
            return handleHttpRequest(config);
        }

        //add a list of notes
        function addNotes(notes) {
            if (notes === null || angular.isUndefined(notes)) {
                return handleInvalidNoteRequest();
            }
            var config = httpRequestManager.getAnonymousHttpPostConfig('', notes);
            config.url = notesApi;
            return handleHttpRequest(config);
        }

        //This takes in text for a new note and wraps it in an object to send to the add notes function
        function addNote(entityId, type, noteText) {
            if (!entityId || !type || !noteText) {
                return handleInvalidNoteRequest();
            }

            return initializeNote(entityId, type, noteText).then(function(newNote){
                return addNotes({ comments: [newNote] });
            });
        }

        //intialize a new note to be added
        function initializeNote(entityId, type, enteredText) {
            return bmUser.load().then(function(){
                return {
                    isdeleted: false,
                    createdbyid: bmUser.contactId,
                    entityid: entityId,
                    notedata: enteredText,
                    createdbyproduct: $location.absUrl(),
                    notetype: type,
                    notenumber: 0,
                    parent: '',
                    companyid: bmUser.companyId
                };
            });
        }

        return factory;
    }

})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.notes')
        .factory('NotesClientManager', NotesClientManager);

    NotesClientManager.$inject = ['$q', 'httpRequestManager', 'AuthenticatedSessionData'];

    function NotesClientManager($q, httpRequestManager, AuthenticatedSessionData) {
        var factory = {
            getBindings: getBindings
        };
        return factory;

        function getBindings() {
            return AuthenticatedSessionData.getBindings();
        }
    }
})(window.angular);

angular.module('bluemoon.notes.templates', ['notes/edit-note.2js.html', 'notes/existing-note.2js.html', 'notes/new-note.2js.html', 'notes/note-date-string.2js.html', 'notes/notes-modal.2js.html', 'notes/notes.2js.html']);

angular.module("notes/edit-note.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("notes/edit-note.2js.html",
    "<div>\n" +
    "	<div class=\"form-group bmn-row-spacer\" ng-class=\"{'has-error': editCommentForm.comment.$error.count > 0 }\">\n" +
    "		<form id=\"editCommentForm\" name=\"editCommentForm\">\n" +
    "			<textarea class=\"text-small\" froala=\"froalaOptions\" name=\"comment\" ng-model=\"enteredText\"></textarea>\n" +
    "			<div ng-messages=\"editCommentForm.comment.$error\" role=\"alert\">\n" +
    "				<span class=\"msg\" ng-message=\"required\">{{ 'bmn.CommentRequired' | translate }}</span>\n" +
    "			</div>\n" +
    "		</form>\n" +
    "	</div>\n" +
    "	<button class=\"btn btn-default pull-right  bmn-button-spacer\"\n" +
    "		ng-click=\"cancelClick()\"\n" +
    "		translate=\"bmn.Cancel\"></button>\n" +
    "    <button class=\"btn btn-primary pull-right\" ng-disabled=\"isDisabled\"\n" +
    "			ng-click =\"submitClick()\"\n" +
    "    	translate=\"bmn.Update\"></button>\n" +
    "    <button class=\"btn btn-link\" ng-disabled=\"isDisabled\"\n" +
    "    	ng-click=\"deleteClick()\">\n" +
    "        <i class=\"bento-icon-remove\"></i><span translate=\"bmn.Delete\"></span>\n" +
    "    </button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("notes/existing-note.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("notes/existing-note.2js.html",
    "<li class=\"bmn-comment-box\" ng-show=\"!editingThis\">\n" +
    "      <div class=\"row\">\n" +
    "            <div class=\"col-md-3\">\n" +
    "                  <div class=\"bmn-author\">\n" +
    "                        {{note.createdbyGivenName + \" \" + note.createdbyFamilyName}}\n" +
    "                  </div>\n" +
    "                  <bmn-note-date-string timestamp=\"note.changed\"></bmn-note-date-string>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-8\">\n" +
    "                  <div class=\"bmn-comment-text\">\n" +
    "                        <p>\n" +
    "                              <div ng-bind-html=\"enteredText\" class=\"enteredComment\"></div>\n" +
    "                        </p>\n" +
    "                  </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-1\">\n" +
    "                  <div ng-if=\"isDisabled\" ng-hide=\"editingAnother || !createdByCurrentUser\"\n" +
    "                        class=\"bmn-lock-icon\">\n" +
    "                        <i class=\"bento-icon-lock\" ng-click=\"isDisabled || editClick()\"></i>\n" +
    "                  </div>\n" +
    "                  <div ng-if=\"!isDisabled\" ng-hide=\"editingAnother || !createdByCurrentUser\"\n" +
    "                        class=\"bmn-edit-icon\">\n" +
    "                        <i class=\"bento-icon-edit\" ng-click=\"isDisabled || editClick()\"></i>\n" +
    "                  </div>\n" +
    "            </div>\n" +
    "      </div>\n" +
    "</li>\n" +
    "");
}]);

angular.module("notes/new-note.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("notes/new-note.2js.html",
    "<div ng-hide=\"isDisabled\">\n" +
    "	<div class=\"form-group bmn-row-spacer\" ng-class=\"{'has-error': addCommentForm.comment.$error.count > 0 }\">\n" +
    "		<form id=\"addCommentForm\" name=\"addCommentForm\">\n" +
    "            <div id=\"addCommentLabel\" translate=\"bmn.CommentRequired\" class=\"bm-comment-label-visually-hidden\"></div>\n" +
    "			<textarea class=\"text-small\" froala=\"froalaOptions\" name=\"comment\" ng-model=\"enteredText\"></textarea>\n" +
    "			<div ng-messages=\"addCommentForm.comment.$error\" role=\"alert\">\n" +
    "				<span class=\"msg\" ng-message=\"required\">{{ 'bmn.CommentRequired' | translate }}</span>\n" +
    "			</div>\n" +
    "		</form>\n" +
    "	</div>\n" +
    "	<button ng-disabled=\"isDisabled\" class=\"btn btn-primary pull-right\" ng-click=\"submitClick()\" translate=\"bmn.Add\"></button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("notes/note-date-string.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("notes/note-date-string.2js.html",
    "<div class=\"date bmn-sub-text\">\n" +
    "	<div ng-show=\"format === formats.full\">{{timestamp | date: 'medium'}}</div>\n" +
    "	<div ng-show=\"format === formats.minutes\" translate=\"bmn.MinutesAgo\" translate-values=\"{ mins: diffMins }\"></div>\n" +
    "	<div ng-show=\"format === formats.hours\" translate=\"bmn.HoursAgo\" translate-values=\"{ hours: diffHours }\"></div>\n" +
    "</div>");
}]);

angular.module("notes/notes-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("notes/notes-modal.2js.html",
    "<div>\n" +
    "        <bento-alert bento-alert-object=\"alerts\"></bento-alert>\n" +
    "        <button class=\"close\" aria-label=\"close\" ng-click=\"done()\">\n" +
    "                <i  aria-hidden=\"true\" class=\"bento-icon-close-x\"></i>\n" +
    "        </button>\n" +
    "        <div class=\"modal-header\" translate=\"bmn.CommentsAbout\" translate-values=\"{ icon: note.entity.icon, name: note.entity.name }\">\n" +
    "        </div>\n" +
    "        <div bento-busy-loader=\"isLoaderBusy\" busy-loader-size=\"small\" class=\"modal-body\">\n" +
    "                <div class=\"row\" style=\"margin-bottom:10px\">\n" +
    "                        <div class=\"col-md-12\">\n" +
    "                                <bmn-edit-note ng-if=\"isInEditMode\"\n" +
    "                                        note=\"noteToEdit\"\n" +
    "                                        is-locked=\"{{note.entity.locked}}\"\n" +
    "                                        parent-update=\"update(noteToEdit)\"></bmn-edit-note>\n" +
    "                                <bmn-new-note ng-if=\"!isInEditMode\"\n" +
    "                                        entity-id=\"{{note.entity.id}}\"\n" +
    "                                        is-locked=\"{{note.entity.locked}}\"\n" +
    "                                        note-type=\"{{note.type}}\"></bmn-new-note>\n" +
    "                        </div>\n" +
    "                </div>\n" +
    "                <div class=\"row\">\n" +
    "                        <div class=\"col-md-12\">\n" +
    "                                <ul class=\"bmn-comment-list\">\n" +
    "                                        <bmn-existing-note ng-repeat=\"thisNote in notes | orderBy: '-changed' track by thisNote.id\"\n" +
    "                                        note=\"thisNote\" is-locked=\"{{note.entity.locked}}\"></bmn-existing-note>\n" +
    "                                </ul>\n" +
    "                        </div>\n" +
    "                </div>\n" +
    "        </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("notes/notes.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("notes/notes.2js.html",
    "<span ng-if=\"(commentCount * 1) > 0\">\n" +
    "	<button class=\"bento-icon-bubble cursor-pointer\" bento-smart-badge details=\"{type: 'digit', content: {value: commentCount}, color: 'bento-smart-badge-info'}\" ng-click=\"open('lg')\"\n" +
    "	uib-tooltip=\"{{'bmn.Comments' | translate}}\" tooltip-append-to-body=\"true\" tooltip-placement=\"top\"></button>\n" +
    "</span>\n" +
    "<span ng-if=\"(commentCount * 1) === 0\">\n" +
    "	<button  class=\"bento-icon-bubble-empty\"  ng-class=\"getCommentsCursorStyle()\" ng-click=\"isDisabled || open('lg')\"\n" +
    "	uib-tooltip=\"{{'bmn.AddComment' | translate}}\" tooltip-append-to-body=\"true\" tooltip-placement=\"top\"></button>\n" +
    "</span>\n" +
    "");
}]);
